import { render } from "./POIsView.vue?vue&type=template&id=4211d212"
import script from "./POIsView.vue?vue&type=script&lang=js"
export * from "./POIsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__